"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var types = ['DDND', 'DE00', 'DEN0', 'DEP', 'DP00', 'DPBN', 'DPN0', 'DPR0', 'DPSV', 'KPLK', 'SBS', 'SBSV'];

function _default(product) {
  return types.includes(product);
}